import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { upload_s3 } from '../../../UploaderS3';
import useAPI from '../../../../../hooks/useAPI';

import SUTextField from '../../Components/SUTextField';
import NodeEditorChrome from '../../Components/NodeEditorChrome';
import TriggerTypeField from '../../Components/TriggerTypeField';
import useApprovedTemplates from '../../Components/useApprovedTemplates';
import useNodeEditor from '../../Components/useNodeEditor';
import { NODE_THEMES } from '../../Components/NodeTheme';
import {
  InfoCallout,
  ChipButton,
  MediaTile,
  CollapsibleSection,
  ToggleField,
  SegmentedTabs,
  FieldLabel,
  boolOption,
  focusFirstInvalidField,
} from '../../Components/NodeFormKit';
import { getFlowsWildcardError } from '../../Components/flowTriggerRules';

import styledComponent from 'styled-components';
import Select from 'react-select';
import { sendToast } from '../../../../plugins/toastAll';
import { canUseSticker } from '../../Components/stickerMessage';
import ReactPlayer from 'react-player';
import ReactAudioPlayer from 'react-audio-player';

import { FiMessageSquare } from 'react-icons/fi';
import {
  BsTrash3,
  BsFillCameraVideoFill,
  BsFillFileEarmarkTextFill,
  BsFillFileEarmarkPdfFill,
  BsFillFileEarmarkWordFill,
  BsFillFileEarmarkFill,
  BsFileEarmarkExcelFill,
  BsLink45Deg,
  BsPersonVcard
} from 'react-icons/bs';
import {
  IoIosArrowDropdown,
  IoIosArrowDropup,
  IoIosAddCircle,
} from 'react-icons/io';
import { FaImages, FaHeadphones } from 'react-icons/fa';

const BASIC_ANSWER_NODE_COLOR = '#00A884';

const INTERACTION_TABS = [
  { key: 'interactive', label: 'Botones' },
  { key: 'location', label: 'Ubicación' },
  { key: 'contact', label: 'Contacto' },
  { key: 'url', label: 'URL' },
];
import { AiOutlineSelect } from 'react-icons/ai';
import { IoClose } from 'react-icons/io5';
import { FaLocationDot } from "react-icons/fa6";

const BasicAnswer = ({
  selectedNode,
  handleSelectedNode,
  handleNodes,
  removeNode,
  nodes,
  edges,
  editFlow,
  updateBot,
  truncateText,
  customStyles,
  customStylesDark,
  isDark,
  watchSelectedNode,
  handleLoading,
  valueSelectedVariable,
  typeInputValue,
  typeInput,
  resetVariable,
  contextVariables,
  onMouseDown,
  isDragging,
  isExpanded,
  setIsExpanded,
}) => {
  const { urlAPI_1, urlAPI_2, fetchWithAuth } = useAPI();
  const theme = isDark == 'true' ? NODE_THEMES.dark : NODE_THEMES.light;
  const {
    watch,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    setValue,
    getValues,
    clearErrors,
    unregister,
    setError,
  } = useForm({
    user_response: null,
    dynamic_buttons_variable: null,
    dynamic_buttons_variable_description: null,
    regular_expressions_error_message: null,
  });

  const { templates, loading: loadingTemplates } = useApprovedTemplates();

  const watchFileUrlVariable = watch('file_url_variable');
  const { handleInputChange, loadData, saveNode, getIsDirty } = useNodeEditor({
    selectedNode,
    handleSelectedNode,
    nodes,
    edges,
    editFlow,
    updateBot,
    reset,
    getValues,
  });
  const advancedCount = [
    selectedNode.data?.advanced?.isAcceptTerms,
    selectedNode.data?.advanced?.request_name,
    selectedNode.data?.advanced?.confirm_name,
    selectedNode.data?.advanced?.edit_name,
    selectedNode.data?.advanced?.closeChatBot,
    selectedNode.data?.advanced?.nextFlow,
    selectedNode.data?.advanced?.campaign,
  ].filter((option) => option?.id === true).length;

  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [dropdownRegularExpression, setDropdownRegularExpression] = useState(false);
  const [dropdownAdvancedOptions, setDropdownAdvanceOptions] = useState(false);
  const [fileSourceTab, setFileSourceTab] = useState('upload');
  const [interactionTab, setInteractionTab] = useState('interactive');


  const isInteractiveMessage =
    (selectedNode?.data?.options?.length || 0) > 0 ||
    !!selectedNode?.data?.advanced?.dynamic_buttons ||
    !!selectedNode?.data?.advanced?.location ||
    !!selectedNode?.data?.advanced?.request_contact ||
    !!selectedNode?.data?.advanced?.url_button;

  const interactionUsage = {
    interactive:
      (selectedNode?.data?.options?.length || 0) > 0 ||
      !!selectedNode?.data?.advanced?.dynamic_buttons,
    location: !!selectedNode?.data?.advanced?.location,
    contact: !!selectedNode?.data?.advanced?.request_contact,
    url: !!selectedNode?.data?.advanced?.url_button,
  };

  const isInteractionTabBlocked = (key) =>
    INTERACTION_TABS.some(
      (tab) => tab.key !== key && interactionUsage[tab.key]
    );

  const handleDropdown = (property) => {
    switch (property) {
      case 'dropdownAdvancedOptions':
        setDropdownAdvanceOptions(!dropdownAdvancedOptions);
        break;
      case 'dropdownRegularExpression':
        setDropdownRegularExpression(!dropdownRegularExpression);
        break;
      default:
        break;
    }
  };


  const removeOptions = (option, index) => {
    const newOptions = selectedNode.data.options.filter((v, i) => i !== index);
    handleSelectedNode((prevInputValue) => {
      return {
        ...prevInputValue,
        data: {
          ...prevInputValue.data,
          options: newOptions,
        },
      };
    });
    const newNodes = nodes.filter((v) => v.id !== option.idNode);
    handleNodes(newNodes);
  };

  const handleOptions = () => {
    if (selectedNode.data.options.length >= 10) {
      return sendToast({
        type: 'info',
        message: 'Solo se pueden agregar 10 botones u opciones como máximo.',
      });
    }

    const length = selectedNode.data.options.length;
    const item = {
      label: 'Opción ' + (length + 1),
      id: `${selectedNode.id}-${length + 1}-Opción-${length + 1}`,
      name: 'titulo',
    };

    const updatedOptions = [...selectedNode.data.options, item];

    const adjustedOptions =
      length > 3
        ? updatedOptions.map((v) => ({
            ...v,
            description: v.description || '',
          }))
        : updatedOptions;

    handleInputChange('options', adjustedOptions);

    handleInputChange('advanced.nextFlow', {
      label: 'No',
      id: false,
    });
  };

  const saveData = (values) => {
    const flowsWildcardError = getFlowsWildcardError(
      values.trigger_type || selectedNode.data?.trigger_type,
      values.user_response,
      selectedNode.data?.flow_template_id
    );
    if (flowsWildcardError) {
      setError('user_response', { type: 'manual', message: flowsWildcardError });
      return;
    }

    setLoadingUpdate(true);

    const data = {
      title: values.title,
      user_response: values.user_response,
      bot_response: values.bot_response,
      trigger_type: values.trigger_type || 'message',
      file_url_variable: values.file_url_variable || null,
      advanced: {
        ...selectedNode.data?.advanced,
        dynamic_buttons_variable: values.dynamic_buttons_variable,
        dynamic_buttons_variable_custom_title: values.dynamic_buttons_variable_custom_title,
        dynamic_buttons_variable_description: values.dynamic_buttons_variable_description,
        url_button_url: values.url_button_url || null,
        url_button_text: values.url_button_text || null,
        regularExpressions: {
          ...selectedNode.data?.advanced?.regularExpressions,
          errorMessage: values.regular_expressions_error_message,
        },
      },
    };

    saveNode(data, () => {
      setLoadingUpdate(false);
      sendToast({ type: 'success', message: 'Nodo actualizado exitosamente.' });
    });
  };

  const onInvalid = (formErrors) => {
    if (formErrors.regular_expressions_error_message) {
      setDropdownRegularExpression(true);
    }
    focusFirstInvalidField(formErrors);
  };

  const getData = () => {
    let objectData = {
      title: selectedNode.data?.title ?? null,
      user_response: selectedNode.data?.user_response ?? null,
      bot_response: selectedNode.data?.bot_response ?? null,
      trigger_type: selectedNode.data?.trigger_type ?? 'message',
      regular_expressions_error_message: selectedNode.data?.advanced?.regularExpressions?.errorMessage ?? null,
      dynamic_buttons_variable: selectedNode.data?.advanced?.dynamic_buttons_variable ?? null,
      dynamic_buttons_variable_custom_title: selectedNode.data?.advanced?.dynamic_buttons_variable_custom_title ?? null,
      dynamic_buttons_variable_description: selectedNode.data?.advanced?.dynamic_buttons_variable_description ?? null,
      file_url_variable: selectedNode.data?.file_url_variable ?? null,
      url_button_url: selectedNode.data?.advanced?.url_button_url ?? null,
      url_button_text: selectedNode.data?.advanced?.url_button_text ?? null,
    };
    loadData(objectData);
  };

  const getActiveSelect = () => {
    const activeKeys = [
      'isAcceptTerms',
      'request_name',
      'confirm_name',
      'edit_name',
    ];

    return activeKeys.find(
      (key) => selectedNode?.data?.advanced?.[key]?.id === true
    );
  };

  const shouldShowSelect = (key) => {
    const currentNodeId = selectedNode?.id;
    const activeSelect = getActiveSelect();

    if (activeSelect && activeSelect !== key) {
      return false;
    }

    const anotherNodeHasIt = (nodes ?? []).some(
      (node) =>
        node?.data?.advanced?.[key]?.id === true && node.id !== currentNodeId
    );

    return (
      selectedNode?.data?.advanced?.[key]?.id === true || !anotherNodeHasIt
    );
  };

  const onFileInput = async (e, type_file) => {
    const conversionFunctions = {
      image: convertBase64,
      video: async (file) => URL.createObjectURL(file),
      document: convertDocumentBase64,
      audio: convertAudioBase64,
    };

    const conversionFunction = conversionFunctions[type_file];
    if (conversionFunction) {
      let file = e.target.files[0];
      const base64 = await conversionFunction(file);
      if (base64) {
        let file_save = {
          name: file.name,
        };
        const data_file = await uploadToS3(file);

        if (!data_file.error && data_file.data.url && data_file.data.type) {
          file_save['url'] = data_file.data.url;
          file_save['type'] = data_file.data.type;
        }

        handleInputChange('file', file_save);
      }
    }
  };
  const convertBase64 = (file) => {
    return new Promise((res, rej) => {
      var fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        res(fileReader.result);
      };
      fileReader.onerror = (error) => {
        rej(error);
      };
    });
  };
  const convertDocumentBase64 = (file) => {
    return new Promise((res, rej) => {
      var fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        res(fileReader.result);
      };
      fileReader.onerror = (error) => {
        rej(error);
      };
    });
  };
  const convertAudioBase64 = (file) => {
    return new Promise((res, rej) => {
      var fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        res(fileReader.result);
      };
      fileReader.onerror = (error) => {
        rej(error);
      };
    });
  };
  const uploadToS3 = async (file) => {
    try {
      handleLoading(true);
      const max_size = checkMaxSize(file);
      if (max_size) {
        handleLoading(false);
        return {
          error: true,
          description: 'tam_limit_error',
          data: {
            name: file.name,
            size: file.size,
            file: file,
            type: file.type,
          },
        };
      } else {
        const signedUrl = await getSignedUrl(file.name, file.size);
        if (signedUrl) {
          const url = await upload_s3(file, signedUrl);
          handleLoading(false);
          return {
            error: false,
            data: {
              url: url,
              name: file.name,
              size: file.size,
              file: file,
              type: file.type,
            },
          };
        }
        handleLoading(false);
        return {
          error: true,
          description: 'signed_url_error',
          data: {
            name: file.name,
            size: file.size,
            file: file,
            type: file.type,
          },
        };
      }
    } catch (error) {
      handleLoading(false);
      return {
        error: true,
        description: 'unknown_error',
        data: error,
        data: { name: file.name, size: file.size, file: file, type: file.type },
      };
    } finally {
      handleLoading(false);
    }
  };
  const getSignedUrl = async (key_name, size) => {
    try {
      key_name = encodeURIComponent(key_name);
      const url = urlAPI_1 + `getSignedURL/${key_name}/${size}`;
      const options = { method: 'GET', mode: 'cors' };
      const response = await fetchWithAuth(url, options);
      if (response.status === 200) {
        let url_signed = await response.json();
        if (url_signed.error) {
          return false;
        }
        return url_signed;
      } else {
        console.error('Error getting signed URL');
        return false;
      }
    } catch (error) {
      console.error('Error getting signed URL:', error);
      return false;
    }
  };
  const checkMaxSize = (file) => {
    let max_size = false;
    if (file.type.includes('audio') && file.size > 1024 * 1024 * 16) {
      max_size = true;
      sendToast({
        type: 'info',
        message: `El archivo ${file.name} supera el peso máximo permitido para audio: 16MB. Intente enviarlo como documento una vez finalizado el proceso de carga.`,
      });
    }
    if (file.type.includes('video') && file.size > 1024 * 1024 * 16) {
      max_size = true;
      sendToast({
        type: 'info',
        message: `El archivo ${file.name} supera el peso máximo permitido para video: 16MB. Intente enviarlo como documento una vez finalizado el proceso de carga.`,
      });
    }
    if (file.type.includes('image') && file.size > 1024 * 1024 * 5) {
      max_size = true;
      sendToast({
        type: 'info',
        message: `El archivo ${file.name} supera el peso máximo permitido para imagen: 5MB. Intente enviarlo como documento una vez finalizado el proceso de carga.`,
      });
    }
    if (file.type.includes('document') && file.size > 1024 * 1024 * 100) {
      max_size = true;
      sendToast({
        type: 'info',
        message: `El archivo ${file.name} supera el peso máximo permitido para documentos: 100MB. Intente enviarlo como documento una vez finalizado el proceso de carga.`,
      });
    }
    return max_size;
  };
  const renderMedia = (type, file) => {
    switch (true) {
      case type.includes('image'):
        return (
          <img
            src={file?.url}
            alt={file?.name || 'Imagen'}
            className="w-100"
            style={{ borderRadius: '4px' }}
          />
        );
      case type.includes('video'):
        return (
          <ReactPlayer
            url={file?.url}
            loop
            controls
            width="100%"
            height="100%"
            style={{ borderRadius: '4px' }}
          />
        );
      case type.includes('application'):
        const appIcon = type.includes('pdf') ? (
          <BsFillFileEarmarkPdfFill style={{ color: 'red' }} />
        ) : type.includes('csv') || type.includes('xls') ? (
          <BsFileEarmarkExcelFill style={{ color: '#00d591' }} />
        ) : type.includes('docx') ? (
          <BsFillFileEarmarkWordFill style={{ color: '#31acf6' }} />
        ) : (
          <BsFillFileEarmarkFill style={{ color: '#5a5a5a' }} />
        );
        return (
          <div
            className="d-flex align-items-center justify-content-between p-2"
            style={{ background: '#f0f0f0', borderRadius: '4px' }}
          >
            {appIcon}
            <span
              style={{ color: '#282828', fontSize: '9px', overflow: 'hidden' }}
            >
              {file?.name}
            </span>
          </div>
        );
      case type.includes('audio'):
        return (
          <ReactAudioPlayer
            src={file?.url}
            controls
            style={{ width: '100%', height: '20px' }}
            className="custom-audio-player"
          />
        );
      default:
        return null;
    }
  };

  useEffect(() => {
    if (typeInput == 'node') {
      setValue(
        typeInputValue,
        getValues(typeInputValue) + valueSelectedVariable
      );
      resetVariable();
    }
  }, [valueSelectedVariable]);

  useEffect(() => {
    getData();

    const hasInteractive =
      (selectedNode?.data?.options?.length || 0) > 0 ||
      !!selectedNode?.data?.advanced?.dynamic_buttons;
    const hasLocation = !!selectedNode?.data?.advanced?.location;
    const hasUrl = !!selectedNode?.data?.advanced?.url_button;
    const hasRequestContact = !!selectedNode?.data?.advanced?.request_contact;

    if (!hasInteractive && !hasLocation && !hasUrl && hasRequestContact) {
      setInteractionTab('contact');
    } else if (!hasInteractive && !hasLocation && hasUrl) {
      setInteractionTab('url');
    } else {
      setInteractionTab('interactive');
    }
  }, [watchSelectedNode]);

  return (
    <NodeEditorChrome
      icon={FiMessageSquare}
      color={BASIC_ANSWER_NODE_COLOR}
      typeName="Respuesta Básica"
      title={truncateText(selectedNode.data.title)}
      onRemove={() => removeNode(selectedNode.id)}
      canRemove={!selectedNode.data.first}
      onMouseDown={onMouseDown}
      isDragging={isDragging}
      onClose={() => {
        reset();
        handleSelectedNode(null);
        setDropdownAdvanceOptions(false);
        setDropdownRegularExpression(false);
      }}
      formId="basicAnswerForm"
      saving={loadingUpdate}
      isDark={isDark}
      getIsDirty={getIsDirty}
      isExpanded={isExpanded}
      setIsExpanded={setIsExpanded}
    >
        <form id="basicAnswerForm" onSubmit={handleSubmit(saveData, onInvalid)} style={{ width: '100%' }}>
          <div>
            <div className="col p-0">
              <SUTextField
                id="title"
                name="title"
                label="Título:"
                type="text"
                selectedNode={selectedNode}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                {...register('title', {
                  required: {
                    value: true,
                    message: 'Campo requerido.',
                  },
                  pattern: {
                    value: /\S+/,
                    message: 'No puede ser solo espacios en blanco',
                  },
                })}
              />
            </div>
            {!selectedNode.data.first && (
              <div className="col p-0 mt-4">
                <TriggerTypeField
                  value={selectedNode.data?.trigger_type}
                  handleInputChange={handleInputChange}
                  setValue={setValue}
                  isDark={isDark}
                  customStyles={customStyles}
                  customStylesDark={customStylesDark}
                />

              </div>
            )}
            {!selectedNode.data.first && selectedNode.data?.trigger_type === 'flows' && (
              <div className="col p-0 mt-4">
                <label htmlFor="flow_template_id" style={{ color: theme.textSecondary, fontWeight: 600 }}>
                  Plantilla esperada (opcional):
                </label>
                <div className="su-control-group">
                  <Select
                    styles={isDark == 'true' ? customStylesDark : customStyles}
                    className="form-control basic-multi-select"
                    placeholder={loadingTemplates ? 'Cargando plantillas...' : 'Seleccione una plantilla'}
                    name="flow_template_id"
                    value={
                      templates.find(
                        (templateOption) =>
                          String(templateOption.value) === String(selectedNode.data?.flow_template_id || '')
                      ) || null
                    }
                    onChange={(option) => {
                      handleInputChange('flow_template_id', option ? String(option.value) : null);
                      handleInputChange('flow_template_name', option ? option.label : null);
                    }}
                    options={templates}
                    isClearable
                    isLoading={loadingTemplates}
                    classNamePrefix="select"
                    noOptionsMessage={() => 'Sin opciones'}
                    getOptionLabel={(option) => option.label}
                    getOptionValue={(option) => option.value}
                  />
                </div>
                <InfoCallout>
                  Si seleccionas una plantilla, este nodo tipo flujo solo se
                  activará cuando el usuario responda a esa plantilla. Con * (cualquier respuesta) la plantilla es obligatoria y el nodo solo se activa dentro de las 24 h siguientes a su envío.
                </InfoCallout>
              </div>
            )}
            {!selectedNode.data.first && (
              <div className="col p-0 mt-4">
                <SUTextField
                  id="user_response"
                  name="user_response"
                  label="Respuesta del cliente:"
                  placeholder="Escribe la respuesta del Bot"
                  hint="Lo que debe llegar para activar este nodo: el texto que escribe el cliente, el título de un botón, o * para cualquier respuesta. Para varios, separalos con  /  ."
                  type="textArea"
                  selectedNode={selectedNode}
                  getValues={getValues}
                  setValue={setValue}
                  errors={errors}
                  {...register('user_response', {
                    required: {
                      value: selectedNode.data.first ? false : true,
                      message: 'Campo requerido.',
                    },
                    pattern: {
                      value: /\S+/,
                      message: 'No puede ser solo espacios en blanco',
                    },
                  })}
                />
                <InfoCallout title="Importante:">
                  Los nodos se pueden activar con múltiples respuestas según
                  estén configuradas. Para ello debe tener el siguiente formato:
                  Respuesta 1 / Respuesta 2 / Respuesta 3.
                </InfoCallout>
              </div>
            )}
            <div
              className="col p-0 mt-4"
              style={{ overflow: 'visible', position: 'relative' }}
            >
              <SUTextField
                id="bot_response"
                name="bot_response"
                label="Respuesta del Bot:"
                maxLength={isInteractiveMessage ? 1024 : 4096}
                placeholder="Escribe la respuesta del Bot"
                type="textArea"
                showEmoji
                showSticker={canUseSticker(selectedNode.data)}
                showVariables
                selectedNode={selectedNode}
                contextVariables={contextVariables}
                getValues={getValues}
                setValue={setValue}
                errors={errors}
                {...register('bot_response', {
                  required: {
                    value: selectedNode.data.first ? false : true,
                    message: 'Campo requerido.',
                  },
                  pattern: {
                    value: /\S+/,
                    message: 'No puede ser solo espacios en blanco',
                  },
                })}
              />
              <div className="d-flex align-items-center mb-3 mt-2">
                <input
                  name="regularExpressions"
                  id="regularExpressions"
                  type="checkbox"
                  className="cmn-toggle cmn-toggle-round-flat"
                  value={
                    selectedNode.data?.advanced?.regularExpressions?.active ||
                    false
                  }
                  checked={
                    selectedNode.data?.advanced?.regularExpressions?.active ||
                    false
                  }
                  onChange={(e) =>
                    handleInputChange(
                      'advanced.regularExpressions.active',
                      e.target.checked
                    )
                  }
                />
                <label
                  className="mr-2 mb-0"
                  htmlFor="regularExpressions"
                ></label>

                <div
                  style={{
                    fontSize: 12,
                    color: theme.textSecondary,
                    fontWeight: 500,
                  }}
                >
                  Expresiones regulares
                </div>
              </div>
              {selectedNode.data?.advanced?.regularExpressions?.active && (
                <div className="col p-0 mt-2 mb-4 panel-group collapsible">
                  <div className="panel panel-default">
                    <div
                      className="panel-heading p-2"
                      style={{
                        border: `1px solid ${theme.border}`,
                        borderRadius: '8px',
                        backgroundColor: theme.inputBg,
                        color: theme.textPrimary,
                      }}
                    >
                      <div
                        id="title-regularExpression"
                        className="panel-title d-flex justify-content-between align-items-center pointer"
                        onClick={() =>
                          handleDropdown('dropdownRegularExpression')
                        }
                      >
                        <span>Expresiones Regulares</span>
                        {dropdownRegularExpression ? (
                          <IoIosArrowDropup
                            className="pointer mr-3"
                            style={{ fontSize: '20px' }}
                          />
                        ) : (
                          <IoIosArrowDropdown
                            className="pointer mr-3"
                            style={{ fontSize: '20px' }}
                          />
                        )}
                      </div>
                    </div>

                    {dropdownRegularExpression ? (
                      <div
                        className="panel-collapse p-2"
                        style={{
                          borderRadius: '4px',
                        }}
                      >
                        <div
                          className="panel-body"
                          style={{ paddingInline: 0 }}
                        >
                          <div className="col p-0 mt-4">
                            <label>Tipo de expresión: </label>
                            <div className="su-control-group d-flex">
                              <Select
                                styles={
                                  isDark == 'true'
                                    ? customStylesDark
                                    : customStyles
                                }
                                className="form-control basic-multi-select"
                                placeholder="Seleccionar"
                                value={
                                  selectedNode.data?.advanced
                                    ?.regularExpressions?.type || null
                                }
                                name="expression_type"
                                onChange={(value) =>
                                  handleInputChange(
                                    'advanced.regularExpressions.type',
                                    value
                                  )
                                }
                                options={[
                                  {
                                    label: 'Fecha',
                                    id: 'date',
                                  },
                                  {
                                    label: 'Hora',
                                    id: 'hour',
                                  },
                                  {
                                    label: 'Correo',
                                    id: 'mail',
                                  },
                                  {
                                    label: 'Numérico',
                                    id: 'number',
                                  },
                                  {
                                    label: 'Teléfono',
                                    id: 'phone',
                                  },
                                ]}
                                classNamePrefix="select"
                                noOptionsMessage={() => 'Sin opciones'}
                                getOptionLabel={(option) => (
                                  <div
                                    className="option d-flex"
                                    style={{
                                      fontSize: '15px',
                                    }}
                                  >
                                    {option.label}
                                  </div>
                                )}
                                getOptionValue={(option) => option.id}
                              />
                            </div>
                          </div>
                          {!['number', 'mail', 'phone'].includes(
                            selectedNode.data?.advanced?.regularExpressions
                              ?.type?.id
                          ) && (
                            <div className="col p-0 mt-4">
                              <label
                                htmlFor="expressionFormat"
                                style={{
                                  color: theme.textSecondary,
                                  fontWeight: 600,
                                }}
                              >
                                Formato:{' '}
                              </label>
                              <div>
                                <Select
                                  styles={
                                    isDark == 'true'
                                      ? customStylesDark
                                      : customStyles
                                  }
                                  className="form-control basic-multi-select"
                                  placeholder="Seleccionar"
                                  value={
                                    selectedNode.data?.advanced
                                      ?.regularExpressions?.format || false
                                  }
                                  name="expressionFormat"
                                  onChange={(value) =>
                                    handleInputChange(
                                      'advanced.regularExpressions.format',
                                      value
                                    )
                                  }
                                  options={
                                    selectedNode.data?.advanced
                                      ?.regularExpressions?.type?.id === 'date'
                                      ? [
                                          {
                                            label: 'mm/dd/aaaa',
                                            id: 'mm/dd/aaaa',
                                          },
                                          {
                                            label: 'mm/dd/aa',
                                            id: 'mm/dd/aa',
                                          },
                                          {
                                            label: 'dd/mm/aaaa',
                                            id: 'dd/mm/aaaa',
                                          },
                                          {
                                            label: 'dd/mm/aa',
                                            id: 'dd/mm/aa',
                                          },
                                          {
                                            label: 'dd-mm-aaaa',
                                            id: 'dd-mm-aaaa',
                                          },
                                          {
                                            label: 'dd-mm-aa',
                                            id: 'dd-mm-aa',
                                          },
                                          {
                                            label: 'mm-dd-aaaa',
                                            id: 'mm-dd-aaaa',
                                          },
                                          {
                                            label: 'mm-dd-aa',
                                            id: 'mm-dd-aa',
                                          },
                                          {
                                            label: 'aaaa-mm-dd',
                                            id: 'aaaa-mm-dd',
                                          },
                                          {
                                            label: 'm/d/aaaa',
                                            id: 'm/d/aaaa',
                                          },
                                          {
                                            label: 'm/d/aa',
                                            id: 'm/d/aa',
                                          },
                                          {
                                            label: 'd/m/aaaa',
                                            id: 'd/m/aaaa',
                                          },
                                          {
                                            label: 'd/m/aa',
                                            id: 'd/m/aa',
                                          },
                                          {
                                            label: 'm-d-aaaa',
                                            id: 'm-d-aaaa',
                                          },
                                          {
                                            label: 'm-d-aa',
                                            id: 'm-d-aa',
                                          },
                                          {
                                            label: 'd-m-aaaa',
                                            id: 'd-m-aaaa',
                                          },
                                          {
                                            label: 'd-m-aa',
                                            id: 'd-m-aa',
                                          },
                                          {
                                            label: 'aaaa-mm-dd',
                                            id: 'aaaa-mm-dd',
                                          },
                                        ]
                                      : [
                                          {
                                            label: 'hh:mm',
                                            id: 'hh:mm',
                                          },
                                        ]
                                  }
                                  classNamePrefix="select"
                                  noOptionsMessage={() => 'Sin opciones'}
                                  getOptionLabel={(option) => (
                                    <div
                                      className="option d-flex"
                                      style={{
                                        fontSize: '15px',
                                      }}
                                    >
                                      {option.label}
                                    </div>
                                  )}
                                  getOptionValue={(option) => option.id}
                                />
                                <p
                                  style={{
                                    fontSize: 12,
                                    color: theme.textSecondary,
                                    fontWeight: 600,
                                  }}
                                >
                                  Formato de la respuesta que se le solicta al
                                  usuario.
                                </p>
                              </div>
                            </div>
                          )}
                          <div className="col p-0 mt-4">
                            <label
                              htmlFor="expressionErrorMessage"
                              style={{
                                color: theme.textSecondary,
                                fontWeight: 600,
                              }}
                            >
                              Mensaje de error:{' '}
                            </label>
                            <div>
                              <textarea
                                className="form-control"
                                id="expressionErrorMessage"
                                name="expressionErrorMessage"
                                type="text"
                                style={{
                                  width: '100%',
                                  height: '80px',
                                  borderRadius: '4px',
                                }}
                                {...register(
                                  'regular_expressions_error_message',
                                  {
                                    required: {
                                      value: selectedNode.data?.advanced
                                        ?.regularExpressions?.active
                                        ? true
                                        : false,
                                      message: 'Campo requerido.',
                                    },
                                    pattern: {
                                      value: /\S+/,
                                      message:
                                        'No puede ser solo espacios en blanco',
                                    },
                                  }
                                )}
                              />
                              {errors.regular_expressions_error_message && (
                                <Alert>
                                  *{' '}
                                  {
                                    errors.regular_expressions_error_message
                                      .message
                                  }
                                </Alert>
                              )}
                              <p
                                style={{
                                  fontSize: 12,
                                  color: theme.textSecondary,
                                  fontWeight: 600,
                                }}
                              >
                                Mensaje que envía el bot en si la respuesta no
                                cumple con la expresión.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                </div>
              )}
              {!selectedNode?.data?.options?.length && !selectedNode?.data?.advanced?.dynamic_buttons && !selectedNode?.data?.advanced?.location && !selectedNode?.data?.advanced?.request_contact && !selectedNode?.data?.advanced?.url_button && (
                <div className="col p-0 mt-2">
                  <FieldLabel>Multimedia:</FieldLabel>
                  <div style={{ marginBottom: '16px' }}>
                    <SegmentedTabs
                      value={fileSourceTab}
                      onChange={setFileSourceTab}
                      options={[
                        { value: 'upload', label: 'Cargar archivo' },
                        {
                          value: 'variable',
                          label: 'Usar variable',
                          disabled: !!selectedNode.data?.file,
                          disabledHint:
                            'Eliminá el archivo cargado para usar una variable.',
                        },
                      ]}
                    />
                  </div>

                  {fileSourceTab === 'upload' && (
                    <>
                  <div 
                    style={{
                      display: 'grid',
                      gridTemplateColumns: isExpanded ? 'repeat(4, 1fr)' : 'repeat(2, 1fr)',
                      gap: '10px',
                      marginBottom: '12px',
                      opacity: watchFileUrlVariable && watchFileUrlVariable.trim() ? 0.5 : 1,
                      pointerEvents: watchFileUrlVariable && watchFileUrlVariable.trim() ? 'none' : 'auto'
                    }}
                  >
                    <MediaTile icon={FaImages} label="Imagen" htmlFor="images">
                      <input
                        type="file"
                        name="image"
                        id="images"
                        accept="image/gif,image/jpeg,image/jpg,image/png"
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Subir imagen"
                        style={{ display: 'none' }}
                        onChange={(e) => onFileInput(e, 'image')}
                      />
                    </MediaTile>
                    <MediaTile icon={BsFillCameraVideoFill} label="Video" htmlFor="videos">
                      <input
                        type="file"
                        name="videos"
                        id="videos"
                        accept="video/*"
                        style={{ display: 'none' }}
                        onChange={(e) => onFileInput(e, 'video')}
                        multiple
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Subir video"
                      />
                    </MediaTile>
                    <MediaTile icon={BsFillFileEarmarkTextFill} label="Documento" htmlFor="documents">
                      <input
                        type="file"
                        name="document"
                        id="documents"
                        accept=".pdf,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/plain, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                        style={{ display: 'none' }}
                        onChange={(e) => onFileInput(e, 'document')}
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Subir documento"
                      />
                    </MediaTile>
                    <MediaTile icon={FaHeadphones} label="Audio" htmlFor="audios">
                      <input
                        type="file"
                        name="audio"
                        id="audios"
                        accept="audio/*"
                        style={{ display: 'none' }}
                        onChange={(e) => onFileInput(e, 'audio')}
                        multiple
                        data-tooltip-id="my-tooltip"
                        data-tooltip-content="Subir audio"
                      />
                    </MediaTile>
                  </div>
                  <p
                    style={{
                      fontSize: 12,
                      color: theme.textSecondary,
                      fontWeight: 500,
                      textAlign: 'center',
                      margin: 0
                    }}
                  >
                    Multimedia que puedes cargar en la respuesta.
                  </p>

                  {selectedNode.data?.file && (
                    <>
                      {renderMedia(
                        selectedNode.data.file.type,
                        selectedNode.data.file
                      )}
                      <div className="mt-3">
                        <ChipButton
                          tone="danger"
                          full
                          icon={BsTrash3}
                          onClick={() => handleInputChange('file', null)}
                        >
                          Eliminar Multimedia
                        </ChipButton>
                      </div>
                    </>
                  )}
                    </>
                  )}

                  {fileSourceTab === 'variable' && (
                    <>
                      <SUTextField
                        id="file_url_variable"
                        name="file_url_variable"
                        label="Variable con URL de archivo:"
                        placeholder="Ej: {{vo9LoGIok0-webHook.driver.photo}}"
                        type="text"
                        showVariables
                        selectedNode={selectedNode}
                        contextVariables={contextVariables}
                        getValues={getValues}
                        setValue={setValue}
                        errors={errors}
                        disabled={!!selectedNode.data?.file}
                        {...register('file_url_variable', {
                          onChange: (e) => {
                            const value = e.target.value;
                            handleInputChange('file_url_variable', value || null);
                            if (!value || !value.trim()) {
                              handleInputChange('file_type_variable', null);
                            }
                          }
                        })}
                      />
                      {watchFileUrlVariable && watchFileUrlVariable.trim() && (
                        <div className="mt-2">
                          <label style={{ color: theme.textSecondary, fontWeight: 500 }}>Tipo de archivo:</label>
                          <div className="su-control-group">
                            <Select
                              styles={isDark === 'true' ? customStylesDark : customStyles}
                              className="form-control basic-multi-select"
                              placeholder="Seleccionar tipo"
                              value={selectedNode.data?.file_type_variable || null}
                              onChange={(value) => handleInputChange('file_type_variable', value)}
                              options={[
                                { label: 'Imagen', value: 'image/jpeg' },
                                { label: 'Video', value: 'video/mp4' },
                                { label: 'Audio', value: 'audio/mpeg' },
                                { label: 'Documento PDF', value: 'application/pdf' },
                                { label: 'Documento', value: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document' },
                              ]}
                              classNamePrefix="select"
                              noOptionsMessage={() => 'Sin opciones'}
                              getOptionLabel={(option) => option.label}
                              getOptionValue={(option) => option.value}
                            />
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              )}
            </div>

            {!selectedNode?.data?.file && !watchFileUrlVariable && (
              <div className="col p-0 mt-4">
                <FieldLabel>Interacciones disponibles:</FieldLabel>

                <div style={{ marginBottom: '16px' }}>
                  <SegmentedTabs
                    value={interactionTab}
                    onChange={setInteractionTab}
                    options={INTERACTION_TABS.map(({ key, label }) => ({
                      value: key,
                      label,
                      disabled: isInteractionTabBlocked(key),
                      disabledHint:
                        'Quitá lo configurado en la otra pestaña para usar esta.',
                    }))}
                  />
                </div>
              </div>
            )}

            {!selectedNode?.data?.file && interactionTab === 'interactive' && (
              <>
                <div className="col p-0 mt-2">
                  <div className="d-flex align-items-center mb-3">
                    <input
                      name="dynamic_buttons"
                      id="dynamic_buttons"
                      type="checkbox"
                      className="cmn-toggle cmn-toggle-round-flat"
                      checked={selectedNode.data?.advanced?.dynamic_buttons || false}
                      onChange={(e) => handleInputChange('advanced.dynamic_buttons', e.target.checked)}
                    />
                    <label className="mr-2 mb-0" htmlFor="dynamic_buttons"></label>
                    <div style={{ fontSize: 12, color: theme.textSecondary, fontWeight: 500 }}>
                      Botones dinámicos
                    </div>
                  </div>
                </div>
                <div className="col p-0 mt-2">
                  {/* Header: título + chip "Agregar" a la derecha (diseño Pencil) */}
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      marginBottom: '8px',
                    }}
                  >
                    <label style={{ margin: 0 }}>Botones interactivos:</label>
                    <ChipButton icon={IoIosAddCircle} onClick={() => handleOptions()}>
                      Agregar
                    </ChipButton>
                  </div>

                  <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {selectedNode.data.options &&
                      selectedNode.data.options.map((option, index) => {
                        return (
                          <div
                            key={index}
                            style={{
                              borderRadius: '8px',
                              border: `1px solid ${theme.border}`,
                              backgroundColor: theme.inputBg,
                              padding: '8px 10px',
                            }}
                          >
                            {/* Fila compacta: grip · input · acciones */}
                            <div
                              style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px',
                              }}
                            >
                              <input
                                className="form-control"
                                id={option.name}
                                name={option.name}
                                type="text"
                                placeholder="Título del botón"
                                style={{ flex: 1, height: '34px', minWidth: 0 }}
                                value={option.label || ''}
                                maxLength={
                                  selectedNode.data.options.length > 3 ? 24 : 20
                                }
                                onChange={(e) => {
                                  const { value } = e.target;

                                  handleSelectedNode((prevInputValue) => {
                                    const updatedOptions = [
                                      ...prevInputValue.data.options,
                                    ];
                                    const currentOption = updatedOptions[index];
                                    const formattedId = `${
                                      selectedNode.id
                                    }-${updatedOptions.length + 1}-${value
                                      .toLowerCase()
                                      .replace(/[^a-z0-9]+/g, '-')
                                      .replace(/(^-|-$)/g, '')}`;

                                    currentOption.label = value;
                                    currentOption.id = formattedId;

                                    return {
                                      ...prevInputValue,
                                      data: {
                                        ...prevInputValue.data,
                                        options: updatedOptions,
                                      },
                                    };
                                  });
                                }}
                              />
                              {!option.hasOwnProperty('customTitle') && (
                                <button
                                  type="button"
                                  className="border-0 bg-transparent d-flex pointer p-0"
                                  style={{
                                    color: theme.textTertiary,
                                    flexShrink: 0,
                                  }}
                                  onClick={() => {
                                    handleSelectedNode((prevInputValue) => {
                                      const updatedOptions = [
                                        ...prevInputValue.data.options,
                                      ];
                                      updatedOptions[index]['customTitle'] = '';
                                      return {
                                        ...prevInputValue,
                                        data: {
                                          ...prevInputValue.data,
                                          options: updatedOptions,
                                        },
                                      };
                                    });
                                  }}
                                  data-tooltip-id="my-tooltip"
                                  data-tooltip-content="Agregar título personalizado"
                                >
                                  <IoIosAddCircle style={{ fontSize: '16px' }} />
                                </button>
                              )}
                              <button
                                type="button"
                                className="border-0 bg-transparent d-flex pointer p-0"
                                style={{
                                  color: theme.textTertiary,
                                  flexShrink: 0,
                                }}
                                onClick={() => removeOptions(option, index)}
                                data-tooltip-id="my-tooltip"
                                data-tooltip-content="Eliminar Botón"
                              >
                                <IoClose style={{ fontSize: '18px' }} />
                              </button>
                            </div>

                            {/* Título personalizado (si aplica) */}
                            {option.hasOwnProperty('customTitle') && (
                              <div className="mt-2">
                                <label htmlFor={`customTitle_${index}`}>
                                  Título personalizado:
                                </label>
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '6px',
                                  }}
                                >
                                  <input
                                    className="form-control"
                                    id={`customTitle_${index}`}
                                    name={`customTitle_${index}`}
                                    type="text"
                                    style={{ flex: 1, height: '34px', minWidth: 0 }}
                                    value={option.customTitle || ''}
                                    onChange={(e) => {
                                      const { value } = e.target;
                                      handleSelectedNode((prevInputValue) => {
                                        const updatedOptions = [
                                          ...prevInputValue.data.options,
                                        ];
                                        const currentOption =
                                          updatedOptions[index];
                                        currentOption.customTitle = value;
                                        return {
                                          ...prevInputValue,
                                          data: {
                                            ...prevInputValue.data,
                                            options: updatedOptions,
                                          },
                                        };
                                      });
                                    }}
                                  />
                                  <IoClose
                                    className="pointer"
                                    style={{
                                      fontSize: '18px',
                                      color: theme.textTertiary,
                                      flexShrink: 0,
                                    }}
                                    onClick={() => {
                                      handleSelectedNode((prevInputValue) => {
                                        const updatedOptions = [
                                          ...prevInputValue.data.options,
                                        ];
                                        delete updatedOptions[index][
                                          'customTitle'
                                        ];
                                        return {
                                          ...prevInputValue,
                                          data: {
                                            ...prevInputValue.data,
                                            options: updatedOptions,
                                          },
                                        };
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                            )}

                            {/* Descripción (cuando hay más de 3 botones = lista) */}
                            {selectedNode.data.options.length > 3 && (
                              <div className="mt-2">
                                <label htmlFor={`${option.name}_description`}>
                                  Descripción (opcional):
                                </label>
                                <textarea
                                  className="form-control"
                                  id={`${option.name}_description`}
                                  name={`${option.name}_description`}
                                  style={{ width: '100%', height: '35px' }}
                                  value={option.description || ''}
                                  maxLength={76}
                                  onChange={(e) => {
                                    const { value } = e.target;

                                    handleSelectedNode((prevInputValue) => {
                                      const updatedOptions = [
                                        ...prevInputValue.data.options,
                                      ];
                                      const currentOption = updatedOptions[index];
                                      currentOption.description = value;

                                      return {
                                        ...prevInputValue,
                                        data: {
                                          ...prevInputValue.data,
                                          options: updatedOptions,
                                        },
                                      };
                                    });
                                  }}
                                />
                              </div>
                            )}
                          </div>
                        );
                      })}
                  </div>
                  <p
                    style={{
                      fontSize: 12,
                      color: theme.textSecondary,
                      fontWeight: 500,
                      marginTop: '8px',
                    }}
                  >
                    Al ingresar más de tres botones se enviarán como lista.
                  </p>
                </div>
                  {selectedNode.data?.advanced?.dynamic_buttons && (
                    <div>
                      <div className="mt-2">
                        <SUTextField
                          id="dynamic_buttons_variable"
                          name="dynamic_buttons_variable"
                          label="Título:"
                          type="text"
                          showEmoji
                          showVariables
                          typeVariables={['api']}
                          contextVariables={contextVariables}
                          selectedNode={selectedNode}
                          getValues={getValues}
                          setValue={setValue}
                          errors={errors}
                          {...register('dynamic_buttons_variable', {
                            required: {
                              value: selectedNode.data?.advanced?.dynamic_buttons ? true : false,
                              message: 'Campo requerido.',
                            },
                            pattern: {
                              value: /\S+/,
                              message: 'No puede ser solo espacios en blanco',
                            },
                          })}
                        />
                      </div>
                      <div className="mt-2">
                        <SUTextField
                          id="dynamic_buttons_variable_custom_title"
                          name="dynamic_buttons_variable_custom_title"
                          label="Título personalizado:"
                          type="text"
                          showEmoji
                          showVariables
                          typeVariables={['api']}
                          contextVariables={contextVariables}
                          selectedNode={selectedNode}
                          getValues={getValues}
                          setValue={setValue}
                          errors={errors}
                          {...register('dynamic_buttons_variable_custom_title')}
                        />
                      </div>
                      <div className="mt-2">
                        <SUTextField
                          id="dynamic_buttons_variable_description"
                          name="dynamic_buttons_variable_description"
                          label="Descripción:"
                          type="text"
                          showEmoji
                          showVariables
                          typeVariables={['api']}
                          contextVariables={contextVariables}
                          selectedNode={selectedNode}
                          getValues={getValues}
                          setValue={setValue}
                          errors={errors}
                          {...register('dynamic_buttons_variable_description', {
                            pattern: {
                              value: /\S+/,
                              message: 'No puede ser solo espacios en blanco',
                            },
                          })}
                        />
                      </div>
                    </div>
                  )}
              </>
            )}

            {interactionTab === 'location' && (
              <div className="col p-0 mt-2">
                <div className="d-flex align-items-center mb-3">
                  <input
                    name="location"
                    id="location"
                    type="checkbox"
                    className="cmn-toggle cmn-toggle-round-flat"
                    checked={selectedNode.data?.advanced?.location || false}
                    onChange={(e) => handleInputChange('advanced.location', e.target.checked)}
                  />
                  <label className="mr-2 mb-0" htmlFor="location"></label>
                  <div style={{ fontSize: 12, color: theme.textSecondary, fontWeight: 500 }}>
                    Solicitar ubicación
                  </div>
                </div>
                {selectedNode.data?.advanced?.location && (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '6px',
                      height: '36px',
                      width: '100%',
                      borderRadius: '8px',
                      border: `1px dashed color-mix(in srgb, ${BASIC_ANSWER_NODE_COLOR} 35%, var(--su-surface, #ffffff))`,
                      backgroundColor: `color-mix(in srgb, ${BASIC_ANSWER_NODE_COLOR} 8%, var(--su-surface, #ffffff))`,
                      color: BASIC_ANSWER_NODE_COLOR,
                      fontSize: '13px',
                      fontWeight: 600,
                    }}
                  >
                    <FaLocationDot style={{ fontSize: '14px' }} />
                    Enviar ubicación
                  </div>
                )}
              </div>
            )}
            {interactionTab === 'contact' && (
              <div className="col p-0 mt-2">
                <div className="d-flex align-items-center mb-3">
                  <input
                    name="request_contact"
                    id="request_contact"
                    type="checkbox"
                    className="cmn-toggle cmn-toggle-round-flat"
                    checked={selectedNode.data?.advanced?.request_contact || false}
                    onChange={(e) => handleInputChange('advanced.request_contact', e.target.checked)}
                  />
                  <label className="mr-2 mb-0" htmlFor="request_contact"></label>
                  <div style={{ fontSize: 12, color: theme.textSecondary, fontWeight: 500 }}>
                    Solicitar número de teléfono
                  </div>
                </div>
                {selectedNode.data?.advanced?.request_contact && (
                  <>
                    <div
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: '6px',
                        height: '36px',
                        width: '100%',
                        borderRadius: '8px',
                        border: `1px dashed color-mix(in srgb, ${BASIC_ANSWER_NODE_COLOR} 35%, var(--su-surface, #ffffff))`,
                        backgroundColor: `color-mix(in srgb, ${BASIC_ANSWER_NODE_COLOR} 8%, var(--su-surface, #ffffff))`,
                        color: BASIC_ANSWER_NODE_COLOR,
                        fontSize: '13px',
                        fontWeight: 600,
                      }}
                    >
                      <BsPersonVcard style={{ fontSize: '14px' }} />
                      Compartir número
                    </div>
                    <InfoCallout title="Importante:">
                      Este botón solo se puede enviar dentro de la ventana de 24
                      horas. Si el usuario lleva más tiempo inactivo, usa un nodo
                      de plantilla. El texto del botón lo define WhatsApp y no se
                      puede personalizar.
                    </InfoCallout>
                  </>
                )}
              </div>
            )}
            {interactionTab === 'url' && (
              <div className="col p-0 mt-2">
                <div className="d-flex align-items-center mb-3">
                  <input
                    name="url_button"
                    id="url_button"
                    type="checkbox"
                    className="cmn-toggle cmn-toggle-round-flat"
                    checked={selectedNode.data?.advanced?.url_button || false}
                    onChange={(e) => {
                      const newVal = e.target.checked;
                      handleInputChange('advanced.url_button', newVal);
                      if (!newVal) {
                        handleInputChange('advanced.url_button_url', null);
                        handleInputChange('advanced.url_button_text', null);
                        setValue('url_button_url', '');
                        setValue('url_button_text', '');
                        unregister('url_button_url');
                        unregister('url_button_text');
                        clearErrors(['url_button_url', 'url_button_text']);
                      }
                    }}
                  />
                  <label className="mr-2 mb-0" htmlFor="url_button"></label>
                  <div style={{ fontSize: 12, color: theme.textSecondary, fontWeight: 500 }}>
                    Activar botón URL
                  </div>
                </div>
                {selectedNode.data?.advanced?.url_button && (
                  <div>
                    <SUTextField
                      id="url_button_url"
                      name="url_button_url"
                      label="URL:"
                      placeholder="https://ejemplo.com o {{variable}}"
                      type="text"
                      showVariables
                      selectedNode={selectedNode}
                      contextVariables={contextVariables}
                      getValues={getValues}
                      setValue={setValue}
                      errors={errors}
                      {...register('url_button_url', {
                        validate: (value) => {
                          if (selectedNode.data?.advanced?.url_button && (!value || value.trim() === '')) {
                            return 'Campo requerido.';
                          }
                          return true;
                        },
                        onChange: (e) => {
                          handleInputChange('advanced.url_button_url', e.target.value);
                        }
                      })}
                    />
                    <SUTextField
                      id="url_button_text"
                      name="url_button_text"
                      label="Texto del botón:"
                      placeholder="Ver enlace o {{variable}}"
                      type="text"
                      showVariables
                      selectedNode={selectedNode}
                      contextVariables={contextVariables}
                      getValues={getValues}
                      setValue={setValue}
                      errors={errors}
                      {...register('url_button_text', {
                        onChange: (e) => {
                          handleInputChange('advanced.url_button_text', e.target.value);
                        }
                      })}
                    />
                  </div>
                )}
              </div>
            )}
            <div className="col p-0 mt-4">
              <CollapsibleSection
                title="Opciones avanzadas"
                count={advancedCount}
                open={dropdownAdvancedOptions}
                onToggle={() => handleDropdown('dropdownAdvancedOptions')}
              >
                      {shouldShowSelect('isAcceptTerms') && (
                        <div className="col p-2 mt-2">
                          <ToggleField
                            id="isAcceptTerms"
                            label="Términos y condiciones"
                            hint="La opción o botón que confirma la aceptación debe llevar en el título la palabra Acepto o Accept."
                            checked={
                              selectedNode?.data?.advanced?.isAcceptTerms
                                ?.id === true
                            }
                            onChange={(checked) =>
                              handleInputChange(
                                'advanced.isAcceptTerms',
                                boolOption(checked)
                              )
                            }
                          />
                        </div>
                      )}
                      {selectedNode.data?.first && (
                        <div className="col p-2">
                          <ToggleField
                            id="campaign"
                            label="Campañas"
                            checked={
                              selectedNode?.data?.advanced?.campaign?.id ===
                              true
                            }
                            onChange={(checked) =>
                              handleInputChange(
                                'advanced.campaign',
                                boolOption(checked)
                              )
                            }
                          />
                          {selectedNode?.data?.advanced?.campaign?.id ==
                            true && (
                            <div className="col p-0 mt-2">
                              <div>
                                {selectedNode?.data?.advanced?.campaign_options?.map(
                                  (option, index) => {
                                    const maxCampaignLabel =
                                      selectedNode?.data?.advanced
                                        ?.campaign_options.length > 3
                                        ? 24
                                        : 20;

                                    return (
                                      <div className="col p-0 mt-2" key={index}>
                                        <label
                                          htmlFor={`campaign-option-${index}`}
                                          style={{
                                            color: theme.textSecondary,
                                            fontWeight: 500,
                                          }}
                                        >
                                          Título:{' '}
                                        </label>
                                        <div>
                                          <div className="d-flex">
                                            <input
                                              id={`campaign-option-${index}`}
                                              name={`campaign-option-${index}`}
                                              type="text"
                                              className="form-control"
                                              style={{
                                                width: '100%',
                                                height: '35px',
                                              }}
                                              value={option.label || ''}
                                              onChange={(e) => {
                                                const { value } = e.target;

                                                handleSelectedNode(
                                                  (prevInputValue) => {
                                                    const updatedCampaignOptions =
                                                      [
                                                        ...prevInputValue.data
                                                          .advanced
                                                          .campaign_options,
                                                      ];
                                                    const option =
                                                      updatedCampaignOptions[
                                                        index
                                                      ];
                                                    const formattedId = `${
                                                      selectedNode.id
                                                    }-campaign_option-${
                                                      updatedCampaignOptions.length +
                                                      1
                                                    }-${value
                                                      .toLowerCase()
                                                      .replace(
                                                        /[^a-z0-9]+/g,
                                                        '-'
                                                      )
                                                      .replace(
                                                        /(^-|-$)/g,
                                                        ''
                                                      )}`;

                                                    option.label = value;
                                                    option.id = formattedId;

                                                    return {
                                                      ...prevInputValue,
                                                      data: {
                                                        ...prevInputValue.data,
                                                        advanced: {
                                                          ...prevInputValue.data
                                                            .advanced,
                                                          campaign_options:
                                                            updatedCampaignOptions,
                                                        },
                                                      },
                                                    };
                                                  }
                                                );
                                              }}
                                            />
                                            <button
                                              className="text-danger border-0 bg-transparent d-block pointer"
                                              onClick={() => {
                                                const newOptions =
                                                  selectedNode?.data?.advanced?.campaign_options?.filter(
                                                    (_, i) => i !== index
                                                  );
                                                handleInputChange(
                                                  'advanced.campaign_options',
                                                  newOptions
                                                );
                                                const newNodes = nodes.filter(
                                                  (v) => v.id !== option.idNode
                                                );
                                                handleNodes(newNodes);
                                              }}
                                            >
                                              <BsTrash3
                                                style={{ fontSize: '18px' }}
                                              />
                                            </button>
                                          </div>
                                          {(!option.label ||
                                            option.label.length >
                                              maxCampaignLabel) && (
                                            <p
                                              style={{
                                                fontSize: 12,
                                                color: '#FF2242',
                                                fontWeight: 500,
                                              }}
                                            >
                                              {!option.label
                                                ? 'Campo para el botón es obligatorio'
                                                : `El campo para el botón no debe ser mayor a ${maxCampaignLabel} caracteres`}
                                            </p>
                                          )}
                                        </div>
                                      </div>
                                    );
                                  }
                                )}
                              </div>

                              <div className="mt-2">
                                <ChipButton
                                  full
                                  icon={AiOutlineSelect}
                                  onClick={() => {
                                    const length =
                                      selectedNode.data?.advanced
                                        ?.campaign_options?.length || 0;
                                    const item = {
                                      label: 'Opción ' + (length + 1),
                                      id: `${selectedNode.id}-campaign_option-${
                                        length + 1
                                      }-Opción-${length + 1}`,
                                    };

                                    const newCampaignOptions = [
                                      ...(selectedNode.data?.advanced
                                        ?.campaign_options || []),
                                      item,
                                    ];

                                    handleInputChange(
                                      'advanced.campaign_options',
                                      newCampaignOptions
                                    );
                                  }}
                                >
                                  Añadir botón de campaña
                                </ChipButton>
                              </div>
                              <p
                                style={{
                                  fontSize: 12,
                                  color: theme.textSecondary,
                                  fontWeight: 600,
                                }}
                              >
                                <strong>Importante: </strong>
                                Estos botones solo se muestran en el constructor
                                de bots como guía del flujo que sigue un bot si
                                la respuesta viene a partir de una campaña, por
                                ende los titulos de cada uno deben ser{' '}
                                <strong>iguales</strong> a las respuesta que se
                                esperan.
                              </p>
                            </div>
                          )}
                        </div>
                      )}
                      {!selectedNode.data?.first && (
                        <div className="col p-2">
                          {shouldShowSelect('request_name') && (
                            <ToggleField
                              id="request_name"
                              label="Solicitud de nombre"
                              checked={selectedNode.data?.advanced?.request_name?.id === true}
                              onChange={(checked) =>
                                handleInputChange('advanced.request_name', boolOption(checked))
                              }
                            />
                          )}
                          {shouldShowSelect('confirm_name') && (
                            <ToggleField
                              id="confirm_name"
                              label="Confirmar nombre"
                              hint="La opción o botón que confirma debe llevar en el título la palabra Confirmar o Confirm."
                              checked={
                                selectedNode.data?.advanced?.confirm_name
                                  ?.id === true
                              }
                              onChange={(checked) =>
                                handleInputChange(
                                  'advanced.confirm_name',
                                  boolOption(checked)
                                )
                              }
                            />
                          )}
                          {shouldShowSelect('edit_name') && (
                            <ToggleField
                              id="edit_name"
                              label="Editar nombre"
                              hint="La opción o botón que edita debe llevar en el título la palabra Editar o Edit."
                              checked={
                                selectedNode.data?.advanced?.edit_name?.id ===
                                true
                              }
                              onChange={(checked) =>
                                handleInputChange(
                                  'advanced.edit_name',
                                  boolOption(checked)
                                )
                              }
                            />
                          )}
                        </div>
                      )}
                      {!selectedNode.data?.first && (
                        <div className="col p-2">
                          <ToggleField
                            id="closeChatBot"
                            label="Cerrar la conversación"
                            hint="Marca este nodo como el último punto de la conversación."
                            checked={
                              selectedNode.data?.advanced?.closeChatBot?.id ===
                              true
                            }
                            onChange={(checked) =>
                              handleInputChange(
                                'advanced.closeChatBot',
                                boolOption(checked)
                              )
                            }
                          />
                        </div>
                      )}
                      {!selectedNode.data?.options.length && (
                        <div className="col p-2">
                          <ToggleField
                            id="nextFlow"
                            label="Saltar nodo"
                            hint="El siguiente nodo se ejecuta automáticamente."
                            last
                            checked={
                              selectedNode.data?.advanced?.nextFlow?.id ===
                              true
                            }
                            onChange={(checked) => {
                              handleInputChange(
                                'advanced.nextFlow',
                                boolOption(checked)
                              );
                              if (!checked) {
                                handleInputChange(
                                  'advanced.nextFlowDelaySeconds',
                                  ''
                                );
                              }
                            }}
                          />

              {selectedNode.data?.advanced?.nextFlow?.id === true && (
              <div className="mt-2">
                <label
                style={{
                  color: theme.textSecondary,
                  fontWeight: 600,
                }}
                >
                Tiempo de espera (segundos):
                </label>
                <input
                type="number"
                className="form-control"
                min="0"
                max="60"
                step="1"
                value={selectedNode.data?.advanced?.nextFlowDelaySeconds ?? ''}
                onChange={(e) => {
                  const rawValue = e.target.value;
                  if (rawValue === '') {
                  handleInputChange('advanced.nextFlowDelaySeconds', '');
                  return;
                  }

                  const parsedValue = Number(rawValue);
                  const boundedValue = Number.isFinite(parsedValue)
                  ? Math.min(Math.max(parsedValue, 0), 60)
                  : 0;

                  handleInputChange(
                  'advanced.nextFlowDelaySeconds',
                  String(Math.floor(boundedValue))
                  );
                }}
                placeholder="0"
                />
                <p
                style={{
                  fontSize: 12,
                  color: theme.textSecondary,
                  marginTop: '6px',
                }}
                >
                Si dejas 0 o vacío, el salto será inmediato. Máximo permitido: 60 segundos.
                </p>
              </div>
              )}
                        </div>
                      )}
              </CollapsibleSection>
            </div>
          </div>
        </form>
    </NodeEditorChrome>
  );
};

export default BasicAnswer;

const Alert = styledComponent.span`
  color: red;
  display: block;
  width: 100%;
`;